// UI
import Breadcrumbs from '@/components/ui/Breadcrumbs'
import ProfileTable from '@/components/profiles/ProfileTable'
import ProfileCreate from '@/components/profiles/ProfileCreate'
import useMe from '@/hooks/useMe'

export default function ProfilesIndex() {
    const { isAdmin } = useMe()
    const breadcrumbs = [
        {
            label: 'Utilisateurs',
        },
    ]

    return (
        <div>
            <Breadcrumbs breadcrumbs={breadcrumbs} />
            {isAdmin && <div className="flex justify-end px-5 py-3"><ProfileCreate /></div>}
            <ProfileTable />
        </div>
    )
}
